export class ApartmentViewerSettings {
    private _isMobile : boolean;
    private _loading: boolean = false;
    private _hasActiveMarker: boolean = false;
    private _onActiveMarkerChange: (hasActiveMarker: boolean) => void = () => {};

    constructor(isMobile: boolean) {
        this._isMobile = isMobile;
    }

    get isMobile(): boolean {
        return this._isMobile;
    }

    set isMobile(value: boolean) {
        this._isMobile = value;
    }

    get loading(): boolean {
        return this._loading;
    }

    set loading(value: boolean) {
        this._loading = value;
    }

    get hasActiveMarker(): boolean {
        return this._hasActiveMarker;
    }

    set hasActiveMarker(value: boolean) {
        this._hasActiveMarker = value;

        if(this._onActiveMarkerChange) {
            this._onActiveMarkerChange(value);
        }

    }

    get onActiveMarkerChange(): (hasActiveMarker: boolean) => void {
        return this._onActiveMarkerChange;
    }

    set onActiveMarkerChange(value: (hasActiveMarker: boolean) => void) {
        this._onActiveMarkerChange = value;
    }


}
